import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge.js";
import moment from "moment";

HighchartsMore(Highcharts);
solidGauge(Highcharts);
const SkriningArea = ({ data, tahun, skala, judul }) => {
  const [kunjungan, setkunjungan] = useState({
    chart: {
      type: "column",
    },
    title: {
      text: `${judul} ${tahun}`,
    },
    // subtitle: {
    //   text:
    //     "Source: " +
    //     '<a href="https://www.ssb.no/en/statbank/table/08940/" ' +
    //     'target="_blank">SSB</a>',
    // },
    xAxis: {
      categories: data?.data_screening
        ? data?.data_screening.map((a) => a.name)
        : [skala],
      crosshair: true,
      accessibility: {
        description: skala,
      },
    },
    yAxis: {
      title: {
        useHTML: true,
        text: "Jumlah Skrining",
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        stacking: "normal",
        dataLabels: {
          enabled: true,
        },
      },
      // series: {
      // events: {
      //   click: function (event) {
      //     setdiag(event.point.category);
      //   },
      // },
      // },
    },
    // // legend: { enabled: false },
    // legend: {
    //   useHTML: true,
    //   squareSymbol: false,
    //   symbolWidth: 0,
    //   // labelFormatter: function () {
    //   //   return '<div><div><span style="margin: 1em"> <i class="ni ni-bold-up ni-2x" style="color: red"></i> Kasus naik</span> <span style="margin: 1em"> <i class="ni ni-bold-down ni-2x" style="color: green"></i>  Kasus Turun</span> <span style="margin: 1em"> <i class="ni ni-fat-add ni-2x" style="color: yellow"></i>  Kasus Baru</span><div></div>';
    //   // },
    // },
    series: [
      {
        name: skala,
        data: data?.data_screening
          ? data?.data_screening.map((a) => a.jumlah)
          : [0],
      },
    ],
  });
  // const [icd, seticd] = useState([]);
  // useEffect(() => {
  //   getLastyearICD();
  // }, [icd]);

  // useEffect(() => {
  //   if (kenaikan.length == 10) {
  //     getICD();
  //   }
  // }, [kenaikan.length]);

  // useEffect(() => {
  //   if (icd.length > 0) {
  //     setkunjungan({
  //       ...kunjungan,
  //       title: {
  //         text: `Grafik Sepuluh Besar Penyakit Tahun ${tahun}`,
  //       },
  //       xAxis: {
  //         ...kunjungan.xAxis,
  //         categories: icd.map((a) => {
  //           return a.icd_code;
  //         }),
  //         labels: {
  //           useHTML: true,
  //           overflow: "allow",
  //           formatter: function (a) {
  //             let dat = kenaikan.find((e) => e.icd_code == a.value);
  //             if (dat) {
  //               if (dat.profit == 1) {
  //                 return (
  //                   "<div>" +
  //                   a.value +
  //                   '  </div><i class="ni ni-bold-up ni-2x" style="color: red"></i>'
  //                 );
  //               } else if (dat.profit == 0) {
  //                 return (
  //                   "<div>" +
  //                   a.value +
  //                   '</div><i class="ni ni-bold-down ni-2x" style="color: green"></i>'
  //                 );
  //               } else {
  //                 return (
  //                   "<div>" +
  //                   a.value +
  //                   '</div><i class="ni ni-far-add ni-2x" style="color: yellow"></i></i>'
  //                 );
  //               }
  //             } else {
  //               return (
  //                 "<div>" +
  //                 a.value +
  //                 '</div><i class="ni ni-fat-add ni-2x" style="color: yellow"></i></i>'
  //               );
  //             }
  //           },
  //         },
  //       },
  //       series: [
  //         {
  //           name: "Jumlah Kasus",
  //           data: icd.map((a) => {
  //             return a.count;
  //           }),
  //         },
  //       ],
  //     });
  //   }
  // }, [icd]);

  useEffect(() => {
    setkunjungan({
      ...kunjungan,
      xAxis: {
        categories: data?.data_screening
          ? data?.data_screening.map((a) => a.name)
          : [skala],
        crosshair: true,
        accessibility: {
          description: skala,
        },
      },
      series: [
        {
          name: skala,
          data: data?.data_screening
            ? data?.data_screening.map((a) => a.jumlah)
            : [0],
        },
      ],
    });
  }, [data]);

  const [date, setdate] = useState({
    frDate: moment().startOf("year").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  });

  // const getICD = async (e) => {
  //   let param = {
  //     puskesmas_id: "DINAS",
  //     frDate: moment([tahun]).startOf("year").format("YYYY-MM-DD"),
  //     enDate: moment([tahun]).endOf("year").format("YYYY-MM-DD"),
  //   };
  //   const res = await apiService.post(
  //     "dashboard/ten_of_mostly_diagnose",
  //     param
  //   );
  //   if (res.code === 200) {
  //     let history = [];
  //     res.data.map((a, k) => {
  //       let x = kenaikan.find((b) => b.icd_code == a.icd_code);
  //       if (x) {
  //         if (x.count > a.count) {
  //           history.push({ ...x, profit: 1 });
  //         } else if (x.count < a.count) {
  //           history.push({ ...x, profit: 0 });
  //         } else {
  //           history.push({ ...x, profit: 2 });
  //         }
  //       }
  //     });
  //     setkenaikan(history);
  //     seticd(res.data);
  //   } else {
  //     console.error("Cannot load data from remote source");
  //   }
  // };

  // const getLastyearICD = async (e) => {
  //   let param = {
  //     puskesmas_id: "DINAS",
  //     frDate: moment([tahun]).subtract(1, "year").startOf("year").format("YYYY-MM-DD"),
  //     enDate: moment([tahun]).subtract(1, "year").endOf("year").format("YYYY-MM-DD"),
  //   };
  //   const res = await apiService.post(
  //     "dashboard/ten_of_mostly_diagnose",
  //     param
  //   );
  //   if (res.code == 200) {
  //     setkenaikan(res.data);
  //   } else {
  //     console.error("Cannot load data from remote source");
  //   }
  // };
  return (
    <div className="col-md-12">
      <HighchartsReact highcharts={Highcharts} options={kunjungan} />
    </div>
  );
};

export default SkriningArea;
